import {React,useState} from 'react'
import '../csscontainer/Form.css'; 

function ContactForm() {
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault(); // prevent actual form submission
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  return (
    <div className="form-card">
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <label>First Name:</label>
          <input type="text" name="firstName" required />
        </div>
        <div className="form-row">
          <label>Last Name:</label>
          <input type="text" name="lastName" required />
        </div>
        <div className="form-row">
          <label>Email:</label>
          <input type="email" name="email" required />
        </div>
        <div className="form-row">
          <label>Company Name:</label>
          <input type="text" name="company" />
        </div>
        <div className="form-row">
          <label>Country:</label>
          <input type="text" name="country" />
        </div>
        <div className="form-row">
          <label>Message:</label>
          <textarea name="message" rows="4" />
        </div>
        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>

      {showModal && (
        <div
          className="modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modalTitle"
        >
          <div className="modal">
            <h2 id="modalTitle">Feature in Progress</h2>
            <p>
              This feature is under process. We’ll notify you when it’s
              available.Till then you can send us email at info@sensiles.com
            </p>
            <div className="modal-actions">
              <button onClick={closeModal} className="btn btn-close">
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ContactForm